export default function IconDoubleCheck(props: { size?: number }) {
  const { size = 16 } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2 12.5l4.5 4.5L15 8.5M10.5 16l1 1L20 8.5"
      />
    </svg>
  );
}
